"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Constants_1 = require("../Constants");
const coord_helper_service_1 = require("../../service/coord-helper.service");
const plugins_1 = require("./plugins");
const Cesium = window.Cesium;
class BoundingSphere extends plugins_1.FdmPlugin {
    constructor() {
        super(...arguments);
        this.debug = Constants_1.Constants.debug_off;
        this.controls = {
            show: { value: true, name: this.meta.translator + '.SHOW', type: 'check' },
            coord: { value: null, name: this.meta.translator + '.COORD', type: 'coord' },
            radius: { value: 0, type: 'info', translateOptions: false, noshow: true },
            grid: { value: 0, type: 'info', noshow: true },
            lat: { value: 0, name: this.meta.translator + '.LAT', type: 'slider', min: -0.001, max: 0.001, step: 0.00001 },
            long: { value: 0, name: this.meta.translator + '.LONG', type: 'slider', min: -0.001, max: 0.001, step: 0.00001 },
            height: { value: 0, name: this.meta.translator + '.HEIGHT', type: 'slider', min: -500, max: 500, step: 0.01 },
        };
        this.originalMatrix = null;
        // plugin specific things
        this.globe = null;
        this.viewer = null;
        this.coordHelper = null;
        this.mapService = null;
    }
    objectInjected(object = null) {
        this.coordHelper = this.services.coordHelper;
        this.mapService = this.services.mapService;
        // we've overridden this, but we want to do some default stuff
        super.objectInjected();
        if (this.debug) {
            console.log('%c sphere.plugin %c objectinjected()', this.debugPrimary, this.debugSecondary, this.object);
        }
        this.viewer = this.mapService.viewer;
        this.globe = this.viewer.scene.globe;
        this.originalMatrix = this.object.modelMatrix;
        // for ( let n=0; n<3; n++ ) {
        //     this.controls['m'+n].value = this.object.modelMatrix[n];
        // }
    }
    itemInjected() {
        if (this.item.vertical_offset) {
            this.controls.height.value = this.item.vertical_offset;
        }
    }
    transferItemHeight() {
    }
    refresh(newvalue = null, section = null) {
        // check in with mama
        super.refresh(newvalue, section);
        this.showHide(this.controls.show.value);
    }
    getCenterCoord() {
        let radians = Cesium.Cartographic.fromCartesian(this.object.boundingSphere.center);
        return new coord_helper_service_1.CoordGeodetic(radians, true);
    }
    updateCenter() {
        let coord = this.getCenterCoord();
        coord.height = coord.height + this.controls.height.value;
        coord.long = coord.long + (this.controls.long.value / 100000);
        coord.lat = coord.lat + (this.controls.lat.value / 100000);
        return this.coordHelper.toCartesian(coord);
    }
    // overriding, using it as a start/stop mechanism
    showHide(state = this.show) {
        // new state
        this.show = state;
        this.wipe();
        // console.log ( '!sphere', this.show, this.object );
        // start
        if (this.object) {
            let original = this.getCenterCoord();
            let surface = this.coordHelper.toCartesian(original);
            let o = new coord_helper_service_1.CoordGeodetic(original);
            o.lat = original.lat + this.controls.lat.value;
            o.long = original.long + this.controls.long.value;
            o.height = original.height + this.controls.height.value;
            let offset = this.coordHelper.toCartesian(o);
            if (this.item) {
                this.item.vertical_offset = this.controls.height.value;
            }
            // let obj = this.object;
            // var origin = Cesium.Cartesian3.fromDegrees(this.controls.lat.value, this.controls.long.value, this.controls.height.value);
            // var cartographic = Cesium.Cartographic.fromCartesian(obj.boundingSphere.center);
            // var surface = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, 0.0);
            // var offset = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, this.controls.height.value || 0);
            var translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3());
            // obj.object.modelMatrix = Cesium.Matrix4.fromTranslation(translation);
            // console.log ( '!sphere', surface, offset );
            this.object.modelMatrix = Cesium.Matrix4.fromTranslation(translation); // Cesium.Matrix4.fromUniformScale(this.controls.m3.value);
            // for ( let n=0; n<6; n++ ) {
            //     this.object.modelMatrix[n] = this.controls['m'+n].value;
            // }
            if (this.show) {
                if (this.object.boundingSphere) {
                    const rad = this.object.boundingSphere.radius;
                    const grid = Math.round(rad / 4);
                    this.controls.coord.value = new coord_helper_service_1.CoordGeodetic(this.globe.ellipsoid.cartesianToCartographic(this.object.boundingSphere.center), true);
                    this.controls.radius.value = Math.round(rad) + 'm';
                    this.controls.grid.value = grid;
                    // this.controls.radius.noshow = false;
                    // this.controls.grid.noshow = false;
                    // console.log ( '!sphere CREATE', this.object.boundingSphere, rad, grid );
                    this.entity('sphere', this.mapService.viewer.entities.add({
                        position: this.object.boundingSphere.center,
                        ellipsoid: {
                            radii: new Cesium.Cartesian3(rad, rad, rad),
                            fill: false,
                            outline: true,
                            outlineColor: Cesium.Color.YELLOW.withAlpha(0.4),
                            outlineWidth: 3.0,
                            slicePartitions: grid,
                            stackPartitions: grid + 5,
                        },
                    }));
                }
                else {
                    this.controls.radius.noshow = true;
                    console.log('sphere.plugin :: no bounding sphere', this.object);
                    this.controls['note'] = { value: this.meta.translator + '.ERROR', type: 'note' };
                }
            }
        }
    }
}
BoundingSphere.meta = {
    label: 'PLUGINS.SPHERE.LABEL',
    name: 'bounding-sphere',
    translator: 'PLUGINS.SPHERE',
    tooltip: 'PLUGINS.SPHERE.TOOLTIP',
    // monitor a shortcut for this plugin
    shortcut: false,
    activeShortcut: true,
    icon: 'globe',
    category: plugins_1.FdmPlugin.category.generic,
    types: [plugins_1.FdmPlugin.types.transformController],
    // we service laslaz/laslaz_tiles (pointclouds) and tms (terrain models)
    // ds_types: [ FdmPlugin.ds_types.all ],
    features: [],
    cardinality: plugins_1.FdmPlugin.cardinality.one,
};
exports.BoundingSphere = BoundingSphere;
